<template>
<div class="main">
    <span class="back"><a href="#/">返回</a></span>
    <div class="chooses">
            <ul class="choose">
                <li><a href="#/loginin">应聘者</a></li>
                <li @click="selectAgency"><a href="#/selectAgency">经销商</a></li>
            </ul>
        </div>
        <div class="show">
            <table border="1" cellpadding="10" cellspacing="0" >
            <tr>
                <th>序号</th>
                <th>企业名称</th>
                <th>联系人</th>
                <th>电话</th>
                <th>邮箱</th>
                <th>客户类型</th>
                <th>留言</th>
                <th>操作</th>
            </tr>
            <tr v-cloak v-for="(item, index) in list" :key="index">
                <td>{{index + 1}}</td>
                <td>{{item.Cname}}</td>
                <td>{{item.contacts}}</td>
                <td>{{item.phone}}</td>
                <td>{{item.Cemail}}</td>
                <td>{{item.type}}</td>
                <td>{{item.Cmessage}}</td>
                <td><button type="submit" @click="delecteAgency(item.Cname,item.phone)">删除</button></td>
            </tr>
        </table>
        </div>
</div>
</template>
<script>
export default {
  name: 'selectAgency',
  data () {
    return {
      list: []
    }
  },
  created () {
    this.selectAgency()
  },
  methods: {
    selectAgency () {
      var that = this
      this.$axios.post('http://' + this.global.url + ':8081/api/user/selectAgency')
        .then(function (res) {
          console.log(res.data)
          that.list = res.data
          console.log(this.list)
        })
        .catch(function (res) {
          console.log(res)
        })
    },
    deleteAgency (Cname, phone) {
      var that = this
      this.$axios.post('http://' + this.global.url + ':8081/api/user/deleteAgency', this.$qs.stringify({
        Cname: Cname,
        phone: phone
      }))
        .then(function (res) {
          console.log(res.data)
          that.selectAgency()
        })
        .catch(function (res) {
          console.log(res)
        })
    }
  }

}
</script>
<style scoped>
.main{
    width: 100%;
    height: auto;
}
.back{
    float: right;
}
.back a{
    text-decoration:none;
}
.back a:link{
    color: black;
}
.back a:visited{
    color: black;
}
.back a:hover{
    color: black;
}
.chooses{
    width: 100%;
    height: 27px;
    border-bottom: 1px solid black;
    /* border: 1px solid red; */
}
.choose{
    list-style: none;
    /* float: left; */
    font-size: 20px;
}
.choose>li a:link{
    color: black;
}
.choose>li a:visited{
    color: black;
}
.choose>li a:hover{
    color: black;
}
.chooses>.choose>li a{
    text-decoration: none;
}
.choose>li a:hover{
    color: black;
}
.choose li{
    width: 10%;
    height: auto;
    float: left;
    /* border: red 1px solid; */
    text-align: center;
}
.choose li:last-child{
    background-color: #F15A24;
}
.show table {
    width: 70%;
    margin-left: 15%;
    margin-top: 20px;
    text-align: center;
    /* border: 1px black solid; */
}
.show table th{
    background-color: #f1ecec;
}
</style>



// WEBPACK FOOTER //
// src/components/loginin/selectAgency.vue